import axios from 'axios';

// Configuración base
//const API_URL = process.env.REACT_APP_API_URL || 'http://192.168.0.10:8000/api';  //Lan Itá
const API_URL = process.env.REACT_APP_API_URL || 'http://192.168.1.6:8000/api';  //Lan Areguá/Itauguá
//const API_URL = process.env.REACT_APP_API_URL || 'http://192.168.112.10:8000/api';
//const API_URL = process.env.REACT_APP_API_URL || 'http://10.13.57.115:8000/api'; //Lan Poli

/**
 * Configuración de API - Sistema Completo
 * Path: backoffice-web/src/services/api.js
 * Última modificación: 2025-01-02 06:35
 * Dev: cpalacios01@gmail.com | +595994648273
 */

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Interceptor para agregar token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para manejar errores
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// ===================================
// AUTENTICACIÓN
// ===================================
export const authService = {
  login: (email, password, deviceName = 'web-admin') =>
    api.post('/login', { email, password, device_name: deviceName }),
  
  logout: () => 
    api.post('/logout'),
  
  me: () => 
    api.get('/me'),
};

// ===================================
// ITINERARIOS (NUEVO)
// ===================================
export const itinerarioService = {
  list: () => api.get('/itinerarios'),
  activos: () => api.get('/itinerarios/activos'),
  get: (id) => api.get(`/itinerarios/${id}`),
  create: (data) => api.post('/itinerarios', data),
  update: (id, data) => api.put(`/itinerarios/${id}`, data),
  delete: (id) => api.delete(`/itinerarios/${id}`),
  toggleActivo: (id) => api.post(`/itinerarios/${id}/toggle-activo`),
};

// ===================================
// REDONDOS (NUEVO)
// ===================================
export const redondoService = {
  list: (params) => api.get('/redondos', { params }),
  abiertos: () => api.get('/redondos/abiertos'),
  cerradosPendientes: () => api.get('/redondos/cerrados-pendientes'),
  activo: () => api.get('/redondos/activo'), // Para conductores
  get: (id) => api.get(`/redondos/${id}`),
  create: (data) => api.post('/redondos', data),
  cerrar: (id, data) => api.put(`/redondos/${id}/cerrar`, data),
  boletas: (id) => api.get(`/redondos/${id}/boletas`),
  gastos: (id) => api.get(`/redondos/${id}/gastos`),
};

// ===================================
// GASTOS (NUEVO)
// ===================================
export const gastoService = {
  list: () => api.get('/gastos'),
  conceptos: () => api.get('/gastos/conceptos'),
  get: (id) => api.get(`/gastos/${id}`),
  create: (data) => api.post('/gastos', data),
  update: (id, data) => api.put(`/gastos/${id}`, data),
  delete: (id) => api.delete(`/gastos/${id}`),
};

// ===================================
// CHOFERES
// ===================================
export const choferService = {
  list: () => api.get('/choferes'),
  disponiblesParaRedondo: () => api.get('/choferes-disponibles-redondo'), // NUEVO - Solo choferes sin redondo abierto
  get: (id) => api.get(`/choferes/${id}`),
  create: (data) => api.post('/choferes', data),
  update: (id, data) => api.put(`/choferes/${id}`, data),
  delete: (id) => api.delete(`/choferes/${id}`),
  asignarBus: (id, busId) => api.post(`/choferes/${id}/asignar-bus`, { bus_id: busId }),
  historial: (id) => api.get(`/choferes/${id}/historial-cajas`),
};

// ===================================
// BUSES
// ===================================
export const busService = {
  list: () => api.get('/buses'),
  disponibles: () => api.get('/buses-disponibles'),
  activos: () => api.get('/buses-activos'),
  disponiblesParaRedondo: () => api.get('/buses-disponibles-redondo'), // NUEVO - Solo buses activos sin redondo abierto
  get: (id) => api.get(`/buses/${id}`),
  create: (data) => api.post('/buses', data),
  update: (id, data) => api.put(`/buses/${id}`, data),
  delete: (id) => api.delete(`/buses/${id}`),
};

// ===================================
// TARIFAS
// ===================================
export const tarifaService = {
  list: () => api.get('/tarifas'),
  all: () => api.get('/tarifas/all'),
  get: (id) => api.get(`/tarifas/${id}`),
  create: (data) => api.post('/tarifas', data),
  update: (id, data) => api.put(`/tarifas/${id}`, data),
  delete: (id) => api.delete(`/tarifas/${id}`),
};

// ===================================
// CAJAS
// ===================================
export const cajaService = {
  list: () => api.get('/cajas'),
  get: (id) => api.get(`/cajas/${id}`),
  boletas: (id) => api.get(`/cajas/${id}/boletas`),
};

// ===================================
// RENDICIONES (ACTUALIZADO)
// ===================================
export const rendicionService = {
  list: (params) => api.get('/rendiciones', { params }),
  cajasPendientes: () => api.get('/rendiciones/cajas-pendientes'),
  redondosPendientes: () => api.get('/rendiciones/redondos-pendientes'), // NUEVO
  get: (id) => api.get(`/rendiciones/${id}`),
  create: (data) => api.post('/rendiciones', data),
  update: (id, data) => api.put(`/rendiciones/${id}`, data),
};

// ===================================
// DASHBOARD
// ===================================
/*export const dashboardService = {
  stats: () => api.get('/dashboard/stats'),
  reportes: () => api.get('/dashboard/reportes'),
};
*/
export const dashboardService = {
  getStats: () => api.get('/dashboard/stats'),  // ← AGREGADO
  stats: () => api.get('/dashboard/stats'),     // ← Mantenido
  reportes: () => api.get('/dashboard/reportes'),
};

export default api;

// cpalacios01@gmail.com | +595994648273
